<template>
    <div class="modal" ref="addCompanyModal" id="addCompanyModal" role="dialog">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl">
            <div class="modal-content">

                <div class="modal-header bg-white font-bold">
                    <h5 class="modal-title" id="exampleModalCenterTitle">Add Company</h5>
                    <button type="button" class="close text-black" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <div class="modal-body text-grey-darkest">
                    <div class="py-4 px-3 flex flex-wrap flex-lg-nowrap items-stretch">
                        <div class="flex-col w-full lg:w-1/3 pr-4">
                            <div class="mb-1 text-grey-darkest text-sm">To add a contact, first pick a company</div>
                            <div class="mb-4 leading-tight">
                                <label class="text-grey-darkest text-sm" for="companies">Companies</label>
                                <multiselect
                                    id="companies"
                                    v-model="selectedCompany"
                                    @input="fetchContacts"
                                    :options="allCompanies"
                                    :multiple="false"
                                    :close-on-select="true"
                                    :clear-on-select="false"
                                    :preserve-search="false"
                                    :taggable="true"
                                    open-direction="below"
                                    placeholder="Pick a company"
                                    tag-placeholder="Add this company"
                                    label="name"
                                    track-by="id"
                                    :preselect-first="false">
                                </multiselect>
                            </div>
                            <div v-if="contacts.length > 0">
                                <div class="flex justify-content-between pb-4">
                                    <div class="mb-1 text-grey-darkest text-sm">Now add contacts to the current project
                                    </div>
                                    <button @click.prevent.stop="addNewContact()"
                                            class="cursor-pointer border-2 border-followup-nav focus:outline-none font-semibold hover:bg-followup-nav hover:text-white p-2 rounded-full text-base text-followup-nav">
                                        New Contact
                                    </button>
                                </div>
                                <hr class="lg:hidden">
                                <div class="leading-tight">
                                    <label class="text-grey-darkest text-sm">Contacts</label>
                                    <div @click.prevent.stop="addOrRemoveContact(contact)" v-for="contact in contacts"
                                        class="p-2 hover:bg-grey-lighter flex justify-between items-center rounded cursor-pointer">
                                        <div class="flex items-baseline">
                                            <div class="font-medium mr-3 text-base text-grey-darkest">{{ contact.name }}
                                            </div>
                                            <div class="text-base font-light text-grey-darkest hidden lg:inline">
                                                {{ contact.cell }}
                                            </div>
                                        </div>
                                        <button v-if="!contactAddedAlready(contact)"
                                                @click.prevent.stop="addContact(contact)"
                                                class="border-2 border-followup-nav focus:outline-none font-semibold hover:bg-followup-nav hover:text-white material-icons p-1 rounded-full text-base text-followup-nav">
                                            add
                                        </button>
                                        <span v-else @click.prevent.stop="removeContact(contact)"
                                            class="border-2 border-red focus:outline-none font-semibold hover:bg-red hover:text-white material-icons p-1 rounded-full text-base text-red">
                                            close
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="hidden lg:flex border-1 border-grey mr-4"></div>
                        <div class="flex-1">
                            <hr class="lg:hidden">
                            <table class="w-full">
                                <tbody>
                                <tr v-for="contact in form.company_contacts"
                                    class="hover:bg-grey-lighter rounded cursor-pointer">
                                    <td class="p-2 text-base text-grey-darkest">{{ contact.company.name }}</td>
                                    <td class="p-2 font-medium text-base text-grey-darkest">
                                        {{ contact.name }}, {{ contact.title }}
                                    </td>
                                    <td class="p-2 text-sm font-light text-grey-darkest hidden lg:table-cell">
                                        {{ contact.cell }}
                                    </td>
                                    <td class="p-2 text-sm font-light text-grey-darkest hidden lg:table-cell">
                                        {{ contact.email }}
                                    </td>
                                    <td class="pt-2">
                                        <button @click.prevent.stop="removeContact(contact)"
                                                class="focus:outline-none text-base font-light text-grey-darkest hover:text-grey-darkest material-icons">
                                            delete
                                        </button>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <!-- Modal -->
                    <div id="newContactModal" class="modal fade" role="dialog">
                        <div class="modal-dialog">
                            <!-- Modal content-->
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h4 class="modal-title text-lg">New Contact</h4>
                                </div>
                                <div class="modal-body">
                                    <form @keydown="newContactForm.errors.clear($event.target.name)">
                                        <div class="mb-2 flex">
                                            <div class="w-4/5">
                                                <label class="text-grey-darkest text-sm" for="new_contact_name"
                                                    :class="{'text-red': newContactForm.errors.has('name')}">Name</label>
                                                <input v-model="newContactForm.name" id="new_contact_name" name="name"
                                                    maxlength="64"
                                                    class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                                                    :class="{'border-red': newContactForm.errors.has('name')}">
                                                <div class="text-red text-xs" v-if="newContactForm.errors.has('name')">{{
                                                        newContactForm.errors.get('name')
                                                    }}
                                                </div>
                                            </div>
                                            <div class="w-1/5 flex justify-center items-center">
                                                <div class="text-center cursor-pointer table mb-0"
                                                    @click.prevent.stop="openNewCompaniesContactModal()">
                                                    <i class="fa fa-user fa-2x"></i>
                                                    <i class="fa fa-plus-circle text-teal" style="margin-left: -22px"></i>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="mb-2">
                                            <label class="text-sm text-grey-darkest -mb-0" for="email"
                                                :class="{'text-red': newContactForm.errors.has('email')}">Email</label>
                                            <input
                                                class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                                                :class="{'border-red': newContactForm.errors.has('email')}"
                                                type="text" id="email" v-model="newContactForm.email">
                                            <div class="text-red text-xs" v-if="newContactForm.errors.has('email')">{{
                                                    newContactForm.errors.get('email')
                                                }}
                                            </div>
                                        </div>
                                        <div class="mb-2">
                                            <label class="text-sm text-grey-darkest -mb-0" for="cell"
                                                :class="{'text-red': newContactForm.errors.has('cell')}">Cell</label>
                                            <input
                                                class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                                                type="text" id="cell" v-model="newContactForm.cell">
                                            <div class="text-red text-xs" v-if="newContactForm.errors.has('cell')">{{
                                                    newContactForm.errors.get('cell')
                                                }}
                                            </div>
                                        </div>
                                        <div class="mb-2">
                                            <label class="text-sm text-grey-darkest -mb-0" for="new_contact_title"
                                                :class="{'text-red': newContactForm.errors.has('title')}">Title</label>
                                            <input
                                                class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                                                type="text" id="new_contact_title" v-model="newContactForm.title">
                                            <div class="text-red text-xs" v-if="newContactForm.errors.has('title')">{{
                                                    newContactForm.errors.get('title')
                                                }}
                                            </div>
                                        </div>
                                        <div class="mb-2">
                                            <label class="text-sm text-grey-darkest -mb-0"
                                                :class="{'text-red': newContactForm.errors.has('contact_type')}">Contact
                                                Type</label>
                                            <multiselect
                                                class="cursor-pointer"
                                                :options="contact_type_options"
                                                v-model="selectedTypeContact"
                                                :show-labels="false"
                                                @input="newContactForm.errors.clear('contact_type')"
                                                track-by="id"
                                                label="code"
                                                value="id">
                                            </multiselect>
                                            <div class="text-red text-xs" v-if="newContactForm.errors.has('user')">{{
                                                    newContactForm.errors.get('user')
                                                }}
                                            </div>
                                        </div>
                                    </form>
                                    <company-contact-modal ref="CompaniesContactModal" :masks="this.masks" :symbols="this.symbols"
                                                        @selected="parseCompanyContacts"></company-contact-modal>
                                    <project-contact-modal ref="EmailContactModal" :masks="this.masks" :symbols="this.symbols" :exchange="this.exchange" @selected="parseContact"></project-contact-modal>
                                </div>
                                <div class="modal-footer">
                                    <button @click.prevent="newContactSaved"
                                            class="bg-followup-nav hover:bg-followup-nav-darker px-3 py-1 rounded-full text-white focus:outline-none">
                                        Add
                                    </button>
                                    <button
                                        class="bg-grey-darker hover:bg-grey-darker px-3 py-1 rounded-full text-white focus:outline-none"
                                        @click="closeContactSaveModal">
                                        close
                                    </button>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>

                <div class="modal-footer">
                    <button class="btn btn-primary assign-user-btn" @click.prevent="massUpdate()">
                        Assign <i v-if="loadingUpdate" class="fa fa-spin fa-spinner" aria-hidden="true"></i>
                    </button>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import Form from "../../../utils/form";
import Multiselect from 'vue-multiselect';
import Swal from "sweetalert2";

export default {
    name: 'add-company',
    props: {
        checked_project_ids: { type: Array },
        calendar: {},
        masks: {},
        symbols: {},
        exchange: {},
    },
    components: { Multiselect },

    data() {
        return {
            loadingUpdate: false,
            selectedCompany: null,
            selectedTypeContact: null,
            contact_type_options: [],
            allCompanies: [],
            contacts: [],
            newContactForm: new Form({
                id: null,
                name: '',
                email: '',
                cell: '',
                title: '',
                date: null,
                completed: null,
                contact_types_id: null
            }),
            form: new Form({
                project_ids: [],
                company_contacts: [],
            })
        }
    },

    watch: {

        selectedTypeContact(type) {
            this.newContactForm.contact_types_id = type.id;
        },
    },

    created() {
        this.calendarAccess = this.calendar;
    },

    mounted() {
        $("#addCompanyModal").on('hidden.bs.modal', () => this.clear());

        Bus.$on('openEmailContactModalParent', data => {
            this.$refs.EmailContactModal.open();

        });
    },

    methods: {
        open() {
            $(this.$el).modal('show');
            this.form.project_ids = [ ...this.checked_project_ids ];
            this.fetchCompanies();
            this.getContactTypes();
        },

        fetchCompanies(newCompany = null) {
            axios.get(route('api.project.companies')).then(({data}) => {
                this.allCompanies = data.data;

                if (newCompany) this.handleNewCompany(newCompany);
            })
        },

        async handleNewCompany(company) {
            this.selectedCompany = _.find(this.allCompanies, {id: company.id});
            this.fetchContacts();
        },

        fetchContacts() {
            if (this.selectedCompany) {
                axios.get(route('api.company.contacts', {company: this.selectedCompany.id})).then(({data}) => {
                    this.contacts = data.data;
                });
            } else {
                this.contacts = [];
            }
        },

        addNewContact() {
            this.newContactForm.reset();
            $("#newContactModal").modal("show");
        },

        newContactSaved() {
            let self = this;
            self.newContactForm.post(route('api.contact.store', {company: self.selectedCompany.id})).then((res) => {
                $("#newContactModal").modal("hide");
                self.fetchContacts()
            });
        },

        parseCompanyContacts(contact) {
            this.newContactForm.name = contact.name;
            this.newContactForm.cell = contact.cell;
            this.newContactForm.email = contact.email;
        },

        getContactTypes() {
            let self = this;
            axios.get(route('api.settings.codes.contact-type.index')).then(({data}) => {
                self.contact_type_options = data;
                self.contact_type_options.push({id: null, code: ""})
            });
        },

        addContact(contact) {
            this.form.company_contacts.push(contact);
        },

        removeContact(contact) {
            this.form.company_contacts = this.form.company_contacts.filter(function (addedContact) {
                return addedContact.id !== contact.id;
            });
        },

        contactAddedAlready(contact) {
            return this.form.company_contacts.filter(x => contact.id === x.id).length > 0;
        },

        close() {
            $(this.$el).modal('hide');
            this.clear();
        },

        clear() {
            this.form.project_ids     = [];
        },

        closeContactSaveModal() {

            $("#newContactModal").modal("hide");
        },

        openNewCompaniesContactModal(){
            this.$refs.CompaniesContactModal.open();
        },

        openEmailContactModal() {
            this.$refs.EmailContactModal.open();
        },

        parseContact(contact) {
            this.form.contact_name = contact.name;
            this.form.contact_phone = contact.cell;
            this.form.contact_email = contact.email;
        },

        massUpdate()
        {
            if(this.form.company_contacts.length > 0) {

                this.loadingUpdate = true;
                let titleString = this.form.project_ids.length == 1 ? this.form.project_ids.length+' project is selected, are you sure you want to update it?' : this.form.project_ids.length+' projects are selected, are you sure you want to update them?';
                let textString = this.form.project_ids.length == 1 ? 'Record' : 'Records';
                Swal.fire({
                    title: titleString,
                    text: textString+" can't be undo once updated.",
                    icon: "warning",
                    buttons: true,
                    showCancelButton: true,
                    confirmButtonColor: 'red',
                    confirmButtonText: 'I\'m sure!',
                    closeOnConfirm: true,
                    closeOnCancel: true,
                }).then(result => {
                    if (result.value) {
                        this.form.post('/api/project/mass-update/add-company')
                            .then((data) => {
                                this.loadingUpdate = false;
                                this.close();
                                this.$emit('update-finished', data);
                            })
                            .catch((err) => {
                                this.loadingUpdate = false;
                            });
                    }
                });
            }
            else {

                this.getToast().fire({
                    type: 'error',
                    title: 'Company cannot be added without contact!'
                });
            }
        }
    }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
    .assign-user-btn {
        border-radius: 25px !important;
    }
</style>
